import { faqs } from '@/mocks/articles';
import FAQSection from '@/components/feature/FAQSection';

export default function HomeFAQ() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <FAQSection faqs={faqs} title="常见问题" />
      </div>
    </section>
  );
}